import { queryOptions, useQuery } from "@tanstack/react-query"
import { useTranslations } from "next-intl"
import { type BlueprintGraphQLClient } from "@krakentech/blueprint-auth"
import { graphql } from "@/graphql"
import { useGraphQLClient, useSession } from "@/lib/blueprint-auth/client"
import { authRoutesPaths } from "@/routes/auth"
import { dashboardRoutesPaths } from "@/routes/dashboard"

const ViewerQuery = graphql(`
    query Viewer {
        viewer {
            preferredName
        }
    }
`)

function getUseUserHeaderOptions(client: BlueprintGraphQLClient, sub: string, enabled: boolean) {
    return queryOptions({
        queryKey: ["viewer", sub],
        queryFn: async () => await client.request(ViewerQuery),
        staleTime: 1000 * 60 * 5, // 5 minutes
        enabled,
    })
}

export function useUserHeader() {
    const { data: session } = useSession()
    const t = useTranslations("useUserHeader")

    const graphQLClient = useGraphQLClient()
    const viewerQuery = useQuery(
        getUseUserHeaderOptions(
            graphQLClient,
            session?.sub ?? "",
            !!session?.isAuthenticated && session.authMethod !== "scoped"
        )
    )

    return {
        href: dashboardRoutesPaths.accounts.resolve(),
        preferredName: viewerQuery.data?.viewer?.preferredName ?? "",
        preferredNameFallback: t("myAccount"),
        isAuthenticated: !!session?.isAuthenticated && session.authMethod !== "scoped",
        login: {
            href: authRoutesPaths.login.resolve(),
            label: t("account"),
        },
    }
}

useUserHeader.messages = ["useUserHeader"] as const
